/* eslint-disable no-unused-vars */
import styles from "./CopyBtn.module.css";
import { Fragment, useState, useEffect } from "react";
import axios from "axios";

import { toast } from "react-toastify";
import { IconDownloadAudio } from "./Icon";
import { downloadAudio } from "../../store/chat-action";

const DownloadAudio = ({ id }) => {
  const [loading, setLoading] = useState(false);
  // const [existAudio, setExistAudio] = useState(true);

  // const checkExistAudio = async () => {
  //   try {
  //     const audio = `${process.env.REACT_APP_MEDIA_BASE_URL}/storage/audio/custom/${id}/0.mp3`;
  //     const audioData = await axios.get(audio);
  //     if (audioData.status === 200) {
  //       setExistAudio(true);
  //     }
  //     setExistAudio(false);
  //   } catch (error) {
  //     setExistAudio(false);
  //   }
  // };

  // useEffect(() => {
  //   checkExistAudio();
  // }, []);

  const callDownloadAudio = async () => {
    const callAPI = async () => {
      setLoading(true);
      try {
        const response = await downloadAudio(id);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = `full-${id}.mp3`; // Custom filename
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url); // Cleanup
        toast.success("Successfully");
        setLoading(false);
      } catch (error) {
        console.log(error);
        toast.error("Failed to download audio, audio not found");
        setLoading(false);
      }
    };
    callAPI();
  };
  // if (!existAudio) {
  //   return <></>;
  // }
  return (
    <Fragment>
      <div
        onClick={(e) => callDownloadAudio()}
        title="Download Audio"
        className={`${styles["copy-icon"]} ${styles["download-audio-icon-one"]}`}
      >
        <IconDownloadAudio className="size-5" />
      </div>
    </Fragment>
  );
};

export default DownloadAudio;
